import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';

const styles = {
  container: {
    padding: '10px',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto'
  },
  calendarButton: {
    padding: '10px 20px',
    fontSize: '16px',
    marginTop: '20px',
    backgroundColor: '#48CFCB',
    border: 'none',
  },
  createEventSection: {
    textAlign: 'left',
    padding: '10px',
    borderRadius: '8px',
  },
  formLabel: {
    fontWeight: 500
  }
};

const Agenda = () => {
  const [event, setEvent] = useState({
    title: '',
    description: '',
    startDateTime: '',
    endDateTime: '',
  });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // Basit Google Calendar URL oluşturma (OAuth gerektirmez)
  const addToGoogleCalendar = () => {
    // Form validasyonu
    if (!event.title.trim()) {
      setError('Etkinlik başlığı gereklidir');
      return;
    }

    if (!event.startDateTime) {
      setError('Başlangıç tarihi ve saati gereklidir');
      return;
    }

    if (!event.endDateTime) {
      setError('Bitiş tarihi ve saati gereklidir');
      return;
    }

    const startDate = new Date(event.startDateTime);
    const endDate = new Date(event.endDateTime);
    
    if (endDate <= startDate) {
      setError('Bitiş tarihi başlangıç tarihinden sonra olmalıdır');
      return;
    }

    if (startDate < new Date()) {
      setError('Başlangıç tarihi geçmişte olamaz');
      return;
    }

    // Hataları temizle
    setError('');

    try {
      // Format dates for Google Calendar URL
      const formatDateForGoogle = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
      };

      const startFormatted = formatDateForGoogle(startDate);
      const endFormatted = formatDateForGoogle(endDate);

      // Google Calendar URL oluştur
      const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${startFormatted}/${endFormatted}&details=${encodeURIComponent(event.description || '')}&location=&sf=true&output=xml`;

      // Yeni sekmede aç
      window.open(googleCalendarUrl, '_blank');
      
      // Başarı mesajı göster
      setSuccess('Google Takvim sayfası açıldı! Etkinliği kaydetmek için "Kaydet" butonuna tıklayın.');
      
      // Form alanlarını temizle
      setEvent({ title: '', description: '', startDateTime: '', endDateTime: '' });
      
    } catch (err) {
      console.error('Error creating calendar URL:', err);
      setError('Takvim URL\'si oluşturulurken bir hata oluştu');
    }
  };

  const openGoogleCalendar = () => {
    window.open('https://calendar.google.com', '_blank');
  };

  const clearMessages = () => {
    setError('');
    setSuccess('');
  };

  return (
    <div style={styles.container}>
      <div style={styles.createEventSection}>
        <h4 className="mb-4">Yeni Etkinlik Ekle</h4>
        
        {error && (
          <Alert variant="danger" dismissible onClose={clearMessages}>
            <strong>Hata:</strong> {error}
          </Alert>
        )}
        
        {success && (
          <Alert variant="success" dismissible onClose={clearMessages}>
            <strong>Başarılı:</strong> {success}
          </Alert>
        )}
        
        <Form>
          <Form.Group className="mb-3">
            <Form.Label style={styles.formLabel}>Etkinlik Başlığı*</Form.Label>
            <Form.Control
              type="text"
              value={event.title}
              onChange={(e) => setEvent({ ...event, title: e.target.value })}
              placeholder="Etkinlik başlığını girin"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={styles.formLabel}>Açıklama</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={event.description}
              onChange={(e) => setEvent({ ...event, description: e.target.value })}
              placeholder="Etkinlik açıklamasını girin"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={styles.formLabel}>Başlangıç Tarihi ve Saati*</Form.Label>
            <Form.Control
              type="datetime-local"
              value={event.startDateTime}
              onChange={(e) => setEvent({ ...event, startDateTime: e.target.value })}
              required
              min={new Date().toISOString().slice(0, 16)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={styles.formLabel}>Bitiş Tarihi ve Saati*</Form.Label>
            <Form.Control
              type="datetime-local"
              value={event.endDateTime}
              onChange={(e) => setEvent({ ...event, endDateTime: e.target.value })}
              required
              min={event.startDateTime || new Date().toISOString().slice(0, 16)}
            />
          </Form.Group>

          <Button 
            variant="primary" 
            onClick={addToGoogleCalendar}
            className="mb-3 w-100"
            type="button"
          >
            Takvime Ekle
          </Button>
        </Form>

        <Button 
          variant="primary" 
          onClick={openGoogleCalendar}
          style={styles.calendarButton}
          className="d-block w-100"
        >
          Mail Takvimimi Görüntüle
        </Button>

        <div className="mt-3">
          <small className="text-muted">
            <strong>Not:</strong> "Takvime Ekle" butonu Google Takvim sayfasını açar ve etkinlik bilgilerini otomatik doldurur. 
            Etkinliği kaydetmek için Google Takvim'de "Kaydet" butonuna tıklamanız yeterlidir.
          </small>
        </div>

        <div className="mt-3 p-3 bg-light rounded">
          <h6>Nasıl Kullanılır:</h6>
          <ol className="small mb-0">
            <li>Etkinlik bilgilerini doldurun</li>
            <li>"Takvime Ekle" butonuna tıklayın</li>
            <li>Açılan Google Takvim sayfasında "Kaydet" butonuna tıklayın</li>
            <li>Etkinlik takviminize eklenecektir</li>
          </ol>
        </div>


      </div>
    </div>
  );
};

export default Agenda;